<template>
<div class="sa-video-call">
    <controls />
    <div @click="!this.isPrimary ? changeFrame(): ''">
    <streams :key="index" v-for="(remoteStream, index) in remoteStreams" :stream="remoteStream" :domId="remoteStream.getId()" :class="isPrimary ? 'sa-remote' : 'sa-local'" />
    </div>
    <div @click="this.isPrimary ? '' : changeFrame()">
        <streams :stream="localStream" :domId="localStream.getId()" :class="!isPrimary ? 'sa-remote' : 'sa-local'" />
    </div>
    <i class="icon-maximize" @click="changeMinimized" :class="minimized?'sa-maxi':'sa-d-none'"></i>
</div>
</template>

<script>
import AgoraRTCClient from '../../../util/AgoraRTCClient';
import Streams from './Streams.vue';
import {
    bus
} from '../../../main';
import {
    mapGetters
} from "vuex";
const Controls = () => import( /* webpackChunkName: "controls" */ "../Controls.vue");
export default {
    name: "AgoraClient",
    components: {
        Streams,
        Controls
    },
    data() {
        return {
            option: {
                appid: '8c6631a1cc2948f38645017214b8ca12',
                token: '',
                uid: null,
                channel: '',
            },
            disableJoin: false,
            localStream: null,
            minimized: false,
            isPrimary: false,
            remoteStreams: [],
            localControls: {
                muted: true,
                video: true,
                audio: false,
            },

            // rtc: null
        }
    },
    computed: {
        ...mapGetters({
            videocallPayload: "videocallPayload"
        }),
        timerUpdate() {
            return this.$parent.timer
        }
    },
    created() {
        console.log('agora client connected');
        this.rtc = new AgoraRTCClient()
        let rtc = this.rtc
        rtc.on('stream-added', (evt) => {
            let {
                stream
            } = evt
            console.log("[agora] [stream-added] stream-added", stream.getId())
            rtc.client.subscribe(stream)
        })

        rtc.on('stream-subscribed', (evt) => {
            let {
                stream
            } = evt
            // console.log("[agora] [stream-subscribed] stream-added", stream.getId())
            if (!this.remoteStreams.find((it) => it.getId() === stream.getId())) {
                this.remoteStreams.push(stream)
            }
        })

        rtc.on('stream-removed', (evt) => {
            let {
                stream
            } = evt
            console.log('[agora] [stream-removed] stream-removed', stream.getId())
            this.remoteStreams = this.remoteStreams.filter((it) => it.getId() !== stream.getId())
        })

        rtc.on('peer-online', (evt) => {
            console.log(`Peer ${evt.uid} is online`)
        })

        rtc.on('peer-leave', (evt) => {
            this.leaveEvent();
            bus.$emit('DECLINE_CALL');
            console.log(`Peer ${evt.uid} already leave`)
            this.remoteStreams = this.remoteStreams.filter((it) => it.getId() !== evt.uid)
        });
    },
    mounted() {
        let _self = this
        setTimeout(() => {
            _self.joinEvent();
        }, 3000);
        this.$on('onDisconnect', () => {
            _self.leaveEvent()
        })
        this.$on('onChat', () => {
            // need to work with surya for styling optimisation for the
            // video minimize and Dragable 
            // alert('onChat')
            // alert('onChat')
            _self.minimized = !_self.minimized
        })
        this.$on('onMute', () => {
            if (!_self.localControls.muted) {
                _self.localStream.disableAudio()
            } else {
                _self.localStream.enableAudio()
            }
            _self.localControls.muted = !_self.localControls.muted
        })
        this.$on('onVideo', () => {
            if (!_self.localControls.video) {
                _self.localStream.disableVideo()
            } else {
                _self.localStream.enableVideo()
            }
            _self.localControls.video = !_self.localControls.video
        })

    },
    beforeDestroy() {
        console.log('agora client destroyed');
    },
    methods: {
        changeMinimized() {
            this.minimized = !this.minimized;
            this.$parent.$emit('minimized')
            this.$store.dispatch("SET_VIDEO_LAYOUT");
        },
        async joinEvent() {
            console.log('v payload : ', this.videocallPayload);
            this.option.token = this.videocallPayload.token;
            this.option.channel = this.videocallPayload.roomName;
            if (!this.option.appid) {
                console.log('Appid');
                return
            }
            if (!this.option.channel) {
                console.log('Channel Name');
                return
            }
            this.rtc.joinChannel(this.option).then(() => {
                console.log({
                    message: 'Join Success',
                    type: 'success'
                });
                this.$parent.setTimer()
                this.rtc.publishStream().then(async (stream) => {
                    console.log({
                        message: 'Publish Success',
                        type: 'success'
                    });
                    this.localStream = await stream
                }).catch((err) => {
                    console.log('Publish Failure');
                    console.log('publish local error', err);
                })
            }).catch((err) => {
                console.log('Join Failure');
                console.log('join channel error', err)
            })
            this.disableJoin = true
        },
        leaveEvent() {
            this.disableJoin = false
            this.$parent.clearTimer()
            this.rtc.leaveChannel().then(() => {
                console.log({
                    message: 'Leave Success',
                    type: 'success'
                });
            }).catch((err) => {
                console.log('Leave Failure');
                console.log('leave error', err);
            })
            this.localStream = null
            this.remoteStreams = []
            bus.$emit("endCall");
        },
        changeFrame() {
            this.isPrimary = !this.isPrimary
        }
    }
}
</script>
